import { Injectable } from '@angular/core';
import { getQuickCommentHtml } from '../shared/Tools/comment';
import { ElementConfig } from '../shared/ElementConfig/element-config.js';
import { Hook, Tool } from './types.js';
import { AnnotationConfig } from '../shared/annotation-config.js';
import { AnnotatorConfigToolsCode } from '../shared/annotator-config';
import { AnnotatorTool, Type } from '../shared/Tools/annotator-tool';
import { allAnnotatorTools } from '../shared/Tools/registerTools';
import { TranslateService } from '@ngx-translate/core';
import { Visibility } from '../../rl-common/shared/shared/types/visibility.enum';

@Injectable({
  providedIn: 'root'
})
export class AnnotatorJSService {
  annMng: any;
  pluginOn: boolean = false;
  tools: { [code: string]: AnnotatorTool } = {};
  currRotation: number = 0;

  constructor(private translate: TranslateService) {}

  init(toolsDisabled: AnnotatorConfigToolsCode[]): any {
    if (this.pluginOn) return this.tools;
    this.pluginOn = true;
    this.initTools(toolsDisabled);
    this.startPlugins();
    return this.tools;
  }

  initTools(toolsDisabled: AnnotatorConfigToolsCode[]) {
    for (let i = 0; i < allAnnotatorTools.length; i++) {
      let t = allAnnotatorTools[i];
      t.disabled = toolsDisabled.indexOf(t.code) > -1;
      if (t.code == Type.shape) {
        t.attachComment = toolsDisabled.indexOf('SHAPE_NO_CMT') > -1;
      }
      t.showTrash = t.showTrash && toolsDisabled.indexOf(t.code) == -1;
      t.tooltip = this.translate.instant(t.tooltip);
      this.tools[t.code] = t;
    }
  }

  startPlugins() {
    this.annMng = new window['annotator'].App().include(window['annotatorLeganto'], {
      tools: this.tools,
      htmlTemplate: this.getAnnHtml()
    });
    if (this.tools[Type.shape]) {
      this.annMng.include(window['annotatorImageSelect'], {
        htmlTemplate: this.getShapeHtml(this.tools[Type.shape].disabled),
        config: this.tools[Type.shape]
      });
    }

    this.annMng.start();
  }

  start = (config: ElementConfig) => this.annMng.runHook('config', [config]);

  selectTool(tool: Type, attributes: any) {
    sessionStorage.setItem('lgnto.anntool', tool);
    attributes ? sessionStorage.setItem('lgnto.anntoolAttributes', JSON.stringify(attributes)) : sessionStorage.removeItem('lgnto.anntoolAttributes');
    this.runHook('selectTool', tool, attributes);
  }

  getShapeHtml = (isDisabled: boolean) =>
    this.getAnnHtml()
      .replace('quick-action-type', `quick-action-shape`)
      .replace('#QUICK_ACTION_MENU#', getQuickCommentHtml('ann-shape', isDisabled, this.translate.instant('design.tool.comment')));

  getAnnHtml() {
    return `<div class="annotator-outer annotator-hide"><div id="quick-action-type" class="quick-action">
    <div class="justify-content">#QUICK_ACTION_MENU#</div></div></div>`;
  }

  runHook = (hook: Hook, ...args: any) => setTimeout(() => this.annMng.runHook(hook, args), 0);

  save = (ann) => this.runHook('save', ann.id);
  edit = (ann, cb?: () => void) => this.runHook('edit', ann.id, cb);
  delete = (ann?) => this.runHook('delete', ann.id);
  select = (annId) => this.runHook('select', annId);
  unselect = (annId) => this.runHook('unselect', annId);
  hover = (annId) => this.runHook('hover', annId);
  unhover = (annId) => this.runHook('unhover', annId);
  scroll = (annId) => this.runHook('scroll', annId);
  newPage = (page) => this.runHook('newPage', page);
  removeAllByConfig = (config: AnnotationConfig[]) => this.runHook('removeAllByConfig', config);
  disable = (toolsCode) => this.runHook('disable', toolsCode);
  reset = (cb: () => void) => this.runHook('reset', cb);

  load(anns, rotation?) {
    this.currRotation = rotation;
    this.runHook('load', anns, this.currRotation);
  }
  deleteAll = () => this.runHook('deleteAll');
  deleteAllComments = () => this.runHook('deleteAllComments');

  currentTool = (): Tool => sessionStorage['lgnto.leganto-annotator'];
}
